// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProfileSettings_headerLeftBox__whZPb {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}
.ProfileSettings_headerRightBox__WctOj {
  display: flex;
}
.ProfileSettings_heading__DVo6J {
  color: #4d4d4d;
  cursor: default;
  font-family: Inter;
  font-size: 40px;
  font-weight: 600;
  line-height: 48px;
  letter-spacing: -0.001em;
  margin: 0px;
  text-align: left;
}
.ProfileSettings_profileContainer__iM1Ri {
  display: flex;
  flex-direction: column;
}
.ProfileSettings_imageContainer__G9kV2 {
  background-color: #ebe6dd;
  height: 215px;
  margin-bottom: 64px;
}
.ProfileSettings_image__P9c0x {
  border: 8px solid #ffffff;
  border-radius: 4px;
  height: 215px;
  margin: 32px 0px 0px 32px;
  width: 190px;
}
.ProfileSettings_fullNameRow__3G5Sj {
  align-items: center;
  display: flex;
  justify-content: space-between;
  height: 52px;
}
.ProfileSettings_leftBox__80m55 {
  display: flex;
  column-gap: 24px;
}
.ProfileSettings_nameText__ZuObT {
  color: #4d4d4d;
  font-family: Inter;
  font-size: 28px;
  font-weight: 600;
  line-height: 34px;
  letter-spacing: -0.001em;
  margin: 0px;
}
.ProfileSettings_badge__0yYPY {
  align-items: center;
  background-color: #87ad76;
  border-radius: 4px;
  display: flex;
  padding: 6px 12px;
}
.ProfileSettings_badgeText__h4YdI {
  color: #ffffff;
  cursor: default;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  letter-spacing: -0.001em;
  margin: 0px;
}
.ProfileSettings_settingsSections__kU\\+Kf {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
  margin-top: 30px;
}
.ProfileSettings_settingsSectionContainer__LeRNm {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
}
.ProfileSettings_settingsSectionTitle__Qlhhf {
  color: #4d4e4e;
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.001em;
  margin: 0px 0px 8px;
}
.ProfileSettings_settingsSectionText__FSAb6 {
  color: #6e6e6e;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.001em;
  margin: 0px;
}
.ProfileSettings_settingsSectionControllerContainer__-Iwbt {
  display: flex;
  flex-direction: column;
  width: fit-content;
}

.ProfileSettings_step__BifqD {
  font-family: Inter;
  font-size: 26px;
  font-weight: 600;
  color: #5f6d7e;
  padding: 20px 0 30px;
}

.ProfileSettings_saveContainer__3q7W8 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: fixed;
  bottom: 10px;
  left: 0;
}

.ProfileSettings_disabledBtn__zkAFV,
.ProfileSettings_saveButton__442ge {
  display: flex;
  align-items: center;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  background-color: #cb9c2d;
  border-radius: 4px;
  cursor: pointer;
  height: 52px;
  justify-content: center;
  width: 212px;
  color: #fff;
  border: none;
}
.ProfileSettings_disabledBtn__zkAFV {
  opacity: 0.7;
}
.ProfileSettings_alert__13l9C {
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  color: #5f6d7e;
  padding: 20px 0 30px;
  width: 560px;
}

@media screen and (max-width: 460px) {
  .ProfileSettings_nameText__ZuObT {
    font-size: 24px;
    line-height: 29px;
  }
  .ProfileSettings_badgeText__h4YdI {
    font-size: 12px;
  }
  .ProfileSettings_leftBox__80m55 {
    column-gap: 4px;
  }
  .ProfileSettings_badge__0yYPY {
    padding: 6px 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/profileSettings/ProfileSettings.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,OAAO;AACT;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".headerLeftBox {\n  display: flex;\n  flex-direction: column;\n  row-gap: 24px;\n}\n.headerRightBox {\n  display: flex;\n}\n.heading {\n  color: #4d4d4d;\n  cursor: default;\n  font-family: Inter;\n  font-size: 40px;\n  font-weight: 600;\n  line-height: 48px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n  text-align: left;\n}\n.profileContainer {\n  display: flex;\n  flex-direction: column;\n}\n.imageContainer {\n  background-color: #ebe6dd;\n  height: 215px;\n  margin-bottom: 64px;\n}\n.image {\n  border: 8px solid #ffffff;\n  border-radius: 4px;\n  height: 215px;\n  margin: 32px 0px 0px 32px;\n  width: 190px;\n}\n.fullNameRow {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  height: 52px;\n}\n.leftBox {\n  display: flex;\n  column-gap: 24px;\n}\n.nameText {\n  color: #4d4d4d;\n  font-family: Inter;\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 34px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n.badge {\n  align-items: center;\n  background-color: #87ad76;\n  border-radius: 4px;\n  display: flex;\n  padding: 6px 12px;\n}\n.badgeText {\n  color: #ffffff;\n  cursor: default;\n  font-family: Inter;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 17px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n.settingsSections {\n  display: flex;\n  flex-direction: column;\n  row-gap: 40px;\n  margin-top: 30px;\n}\n.settingsSectionContainer {\n  display: flex;\n  flex-direction: column;\n  row-gap: 16px;\n}\n.settingsSectionTitle {\n  color: #4d4e4e;\n  font-family: Inter;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: -0.001em;\n  margin: 0px 0px 8px;\n}\n.settingsSectionText {\n  color: #6e6e6e;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  margin: 0px;\n}\n.settingsSectionControllerContainer {\n  display: flex;\n  flex-direction: column;\n  width: fit-content;\n}\n\n.step {\n  font-family: Inter;\n  font-size: 26px;\n  font-weight: 600;\n  color: #5f6d7e;\n  padding: 20px 0 30px;\n}\n\n.saveContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  position: fixed;\n  bottom: 10px;\n  left: 0;\n}\n\n.disabledBtn,\n.saveButton {\n  display: flex;\n  align-items: center;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  background-color: #cb9c2d;\n  border-radius: 4px;\n  cursor: pointer;\n  height: 52px;\n  justify-content: center;\n  width: 212px;\n  color: #fff;\n  border: none;\n}\n.disabledBtn {\n  opacity: 0.7;\n}\n.alert {\n  font-family: Inter;\n  font-size: 20px;\n  font-weight: 600;\n  color: #5f6d7e;\n  padding: 20px 0 30px;\n  width: 560px;\n}\n\n@media screen and (max-width: 460px) {\n  .nameText {\n    font-size: 24px;\n    line-height: 29px;\n  }\n  .badgeText {\n    font-size: 12px;\n  }\n  .leftBox {\n    column-gap: 4px;\n  }\n  .badge {\n    padding: 6px 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerLeftBox": `ProfileSettings_headerLeftBox__whZPb`,
	"headerRightBox": `ProfileSettings_headerRightBox__WctOj`,
	"heading": `ProfileSettings_heading__DVo6J`,
	"profileContainer": `ProfileSettings_profileContainer__iM1Ri`,
	"imageContainer": `ProfileSettings_imageContainer__G9kV2`,
	"image": `ProfileSettings_image__P9c0x`,
	"fullNameRow": `ProfileSettings_fullNameRow__3G5Sj`,
	"leftBox": `ProfileSettings_leftBox__80m55`,
	"nameText": `ProfileSettings_nameText__ZuObT`,
	"badge": `ProfileSettings_badge__0yYPY`,
	"badgeText": `ProfileSettings_badgeText__h4YdI`,
	"settingsSections": `ProfileSettings_settingsSections__kU+Kf`,
	"settingsSectionContainer": `ProfileSettings_settingsSectionContainer__LeRNm`,
	"settingsSectionTitle": `ProfileSettings_settingsSectionTitle__Qlhhf`,
	"settingsSectionText": `ProfileSettings_settingsSectionText__FSAb6`,
	"settingsSectionControllerContainer": `ProfileSettings_settingsSectionControllerContainer__-Iwbt`,
	"step": `ProfileSettings_step__BifqD`,
	"saveContainer": `ProfileSettings_saveContainer__3q7W8`,
	"disabledBtn": `ProfileSettings_disabledBtn__zkAFV`,
	"saveButton": `ProfileSettings_saveButton__442ge`,
	"alert": `ProfileSettings_alert__13l9C`
};
export default ___CSS_LOADER_EXPORT___;
